import Navbar from '../components/common/navbar';
import Calendar from '../atoms/home/calendar';
import Clients from '../atoms/home/clients';

import NextStepsMobile from '../atoms/home/nextStepsMobile';
import About from '../components/home/about';
import Blog from '../components/home/blog';
import Chat from '../components/home/chat';
import Contact from '../components/home/contact';

import Footer from '../components/home/footer';
import Hero from '../components/home/hero';
import Service from '../components/home/service';
import Storyline from '../components/home/storyline';
import Testimonials from '../components/home/testimonials';
import {
  Fullpage,
  FullPageSections,
  FullpageSection,
} from '@ap.cx/react-fullpage';

export default function Home() {
  return (
    <>
      <Navbar />
      <Fullpage>
        <FullPageSections>
          <FullpageSection>
            <Hero />
          </FullpageSection>
          <FullpageSection>
            <Storyline />
          </FullpageSection>
          <FullpageSection>
            <About />
          </FullpageSection>
          <FullpageSection>
            <Clients />
          </FullpageSection>
          <FullpageSection>
            <Service />
          </FullpageSection>
          <FullpageSection>
            <Testimonials />
          </FullpageSection>
          <FullpageSection>
            <Calendar />
          </FullpageSection>
          <FullpageSection>
            <Blog />
          </FullpageSection>
          <FullpageSection>
            <Contact />
          </FullpageSection>
          <div className="block lg:hidden">
            <FullpageSection>
              <NextStepsMobile />
            </FullpageSection>
          </div>
          <div className="block lg:hidden">
            <FullpageSection>
              <Chat />
            </FullpageSection>
          </div>
          <FullpageSection>
            <Footer />
          </FullpageSection>
        </FullPageSections>
      </Fullpage>
    </>
  );
}
